export default "__VITE_ASSET__DEBqP2Bu__"